import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Spin } from 'antd';
import { useNavigate, useLocation } from "react-router-dom";
import cancelOrderById from "../common/helpers/cancel-order-by-id";
import moment from "moment";

const tableSubRowStyle = { fontSize: 16, borderBottom: "1px solid #cccccc", color: "white", textAlign: "left" }


const TableRowAccumulate = ({ log, x, disableAction, setDisableAction, cancelOrder, setAccumulators, botId }) => {

    return (
        <tr>
            <th style={{ ...tableSubRowStyle, ...(log.status !== 'open' && { color: 'grey' }) }}>{log.symbol || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.status !== 'open' && { color: 'grey' }) }}>{log.side || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.status !== 'open' && { color: 'grey' }) }}>{log.amount || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.status !== 'open' && { color: 'grey' }) }}>{log.price || '-'}</th>
            <th style={{ ...tableSubRowStyle, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', ...(log.status !== 'open' && { color: 'grey' }) }}>{moment(log.created_at).format('h:mm:ss a') || '-'}</th>
            <th style={{ ...tableSubRowStyle, ...(log.status !== 'open' && { color: 'grey' }) }}><span>{log.status === 'open' ? <Button
                disabled={disableAction}
                onClick={() => {
                    message.loading({ content: 'Waiting...', key: 'cancel', duration: 0 });
                    cancelOrderById({ bot_id: x?.bot_id, order_id: log.id, symbol: log.symbol }).then(() => {
                        message.destroy('cancel');
                    }).catch((err) => {
                        message.destroy('cancel');
                    })
                    setAccumulators(previousState => {
                        let newAccumulators = [...previousState]
                        newAccumulators.forEach(accumulator => {
                            if (accumulator.id === x.id) {
                                accumulator.logs.forEach(currentLog => {
                                    if (currentLog.id === log.id) {
                                        currentLog.status = 'canceled';
                                    }
                                })
                            }
                        })
                        return newAccumulators;
                    })
                }}
                style={{ backgroundColor: "#161616", color: "white", borderRadius: 10 }}>Cancel</Button> : log.status}</span></th>
        </tr>
    );
};

export default TableRowAccumulate;